<template>
  <el-col :span="props.spanColumn">
    <div class="label">{{ props.label }}</div>
    <el-input
      ref="inputRef"
      v-model="value"
      :placeholder="settings.placeholder"
      :class="settings.inputClass"
      :size="settings.size"
      :disabled="settings.disabled"
      :maxlength="settings.maxlength"
      :show-word-limit="settings.showWordLimit"
      :type="props.type"
      @focus="handleFocus"
    >
      <template
        v-if="settings.hasSearch"
        #append
      >
        <el-button @click="search"><IconSearch /></el-button>
      </template>
    </el-input>
  </el-col>
</template>

<script setup>
import {
  computed,
  ref,
  nextTick,
} from 'vue';
import IconSearch from '~icons/mdi/search';
//props
const props = defineProps({
  spanColumn: Number,
  label: String,
  type: {
    type: String,
    default: 'text', // Valor predeterminado "text"
  },
  settings: {
    type: Object,
    default: () => ({}),
  },
  modelValue: {
    type: [String, Number, Boolean, Object],
  },
});

const settings = computed(() => ({
  placeholder: '',
  inputClass: '',
  disabled: false,
  maxlength: undefined,
  showWordLimit: false,
  size: 'default',
  hasSearch: false,
  ...props.settings,
}));

const inputRef = ref(null);

const emit = defineEmits(['update:modelValue', 'handleSearch']);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const handleFocus = () => {
  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.focus();
    }
  });
};

const search = () => {
  emit('handleSearch');
};

defineExpose({
  focus: handleFocus,
});
</script>

<style scoped>
.label {
  font-weight: 700;
  color: #111;
}
</style>
